import { useState, useEffect } from 'react'

export const useCalendly = (selectedStore, isInstore) => {
  const [ready, setReady] = useState(false)
  const [returnUrl, setReturnUrl] = useState('')
  const [pickupUrl, setPickupUrl] = useState('')

  useEffect(() => {
    if (selectedStore && isInstore) {
      setReturnUrl(selectedStore?.calendlyReturnUrl)
      setPickupUrl(selectedStore?.calendlyWithdrawalUrl)
      setReady(true)
    }
  }, [selectedStore, isInstore])
  return {
    ready,
    returnUrl,
    pickupUrl,
  }
}
